import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950">
      <div className="text-center">
        <div className="font-display text-6xl font-semibold text-emerald-300">404</div>
        <div className="mt-2 text-slate-400">That page doesn't exist.</div>
        <Link to="/">
          <Button className="mt-6 bg-emerald-600 text-white hover:bg-emerald-500" data-testid="nf-home-btn">Back home</Button>
        </Link>
      </div>
    </div>
  );
}
